import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ILeadAssessmentWithLeadRequest } from '@leads/shared/models/firebase/scheduled-assessment.model';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { PageSubtitleComponent } from '@shared/components/sections/page-subtitle/page-subtitle.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigation, IStepNavigatorConfig } from '@shared/models/step-navigator';

import { ScheduleCardComponent } from '../schedule-card/schedule-card.component';

@Component({
	selector: 'app-schedule-table',
	imports: [CommonModule, PageSubtitleComponent, LoadingStateComponent, ScheduleCardComponent, StepNavigatorComponent],
	templateUrl: './schedule-table.component.html',
	styleUrl: './schedule-table.component.scss',
})
export class ScheduleTableComponent {
	@Input() isLoading: boolean;
	@Input() assessments: Array<ILeadAssessmentWithLeadRequest> = [];
	@Input() navigationConfig: IStepNavigatorConfig;
	@Input() selectedStep: IStepNavigation;
	@Output() selectedStepChange: EventEmitter<IStepNavigation> = new EventEmitter<IStepNavigation>();
}
